import Vue from 'vue'
import {getWithPagination, TagsResource} from '../../util/api'

const initialState = {
  objects: {},
  creatingObject: null, // The object currently being created
  editingObject: null, // The Object currently being editing
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_TAGS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_TAG (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    UNSET_TAG (state, object) {
      Vue.delete(state.objects, object.id) // Vue will take care of wether the key is even in the runningTags list
    },
    CREATING_TAG (state, object) {
      state.creatingObject = object
    },
    EDITING_TAG (state, object) {
      state.editingObject = object
    },
    CREATED_TAG (state, object) {
      state.createdObject = object
    },
    UPDATED_TAG (state, object) {
      state.updatedObject = object
    },
    DELETED_TAG (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_TAG_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    CREATE_TAG_IN_PROGRESS (state, value) {
      state.createInProgress = value
    },
    UPDATE_TAG_IN_PROGRESS (state, value) {
      state.updateInProgress = value
    },
    DELETE_TAG_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    TAGS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  getters: {
  },

  actions: {
    // Retrieve a single tag
    getTag ({ commit }, id) {
      try {
        // Check if we have an up-to-date version of the object. If not, get it.
        commit('GET_TAG_IN_PROGRESS', true)
        TagsResource.get({id: id}).then((response) => {
          commit('GET_TAG_IN_PROGRESS', false)
          commit('SET_TAG', response.body)
        }, () => {
          commit('GET_TAG_IN_PROGRESS', false)
          // @TODO: Implement error handling
        })
      } catch (ex) {
        // Request was most likely cancelled due to existing in flight request
        commit('GET_TAG_IN_PROGRESS', false)
      }
    },

    // Retrieve many tags, based on supplied GET params
    getTags ({ commit }, params) {
      commit('GET_TAG_IN_PROGRESS', true)
      getWithPagination(TagsResource, params, response => {
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_TAGS', response.body.data)
      }, () => {
        // Completion handler
        commit('GET_TAG_IN_PROGRESS', false)
      }, () => {
        // Error handler
        commit('GET_TAG_IN_PROGRESS', false)
      })
    },
    createTag ({ commit }, object) {
      // Create (POST) a TAG
      commit('CREATED_TAG', null)
      commit('CREATE_TAG_IN_PROGRESS', object)
      TagsResource.save({}, object).then((response) => {
        commit('CREATE_TAG_IN_PROGRESS', false)
        commit('CREATED_TAG', response.body)
        commit('SET_TAG', response.body)
      }, () => {
        console.error('Create TAG Failed')
        commit('CREATE_TAG_IN_PROGRESS', false)
        commit('CREATED_TAG', null)
      })
    },

    updateTag ({ commit }, object) {
      // Update (PUT) a TAG
      commit('UPDATED_TAG', null)
      commit('UPDATE_TAG_IN_PROGRESS', object)
      TagsResource.update({id: object.id}, object).then((response) => {
        commit('UPDATE_TAG_IN_PROGRESS', false)
        commit('UPDATED_TAG', response.body)
        commit('SET_TAG', response.body)
      }, () => {
        commit('UPDATE_TAG_IN_PROGRESS', false)
        commit('UPDATED_TAG', null)
      })
    },

    deleteTag ({ commit }, object) {
      // Update (PUT) a TAG
      commit('DELETED_TAG', null)
      commit('DELETE_TAG_IN_PROGRESS', object)
      TagsResource.delete({id: object.id}).then(() => {
        commit('DELETE_TAG_IN_PROGRESS', false)
        commit('DELETED_TAG', object)
        commit('UNSET_TAG', object)
      }, () => {
        commit('DELETE_TAG_IN_PROGRESS', false)
        commit('DELETED_TAG', null)
      })
    },

    clearAll ({ commit }) {
      commit('TAGS_CLEAR_ALL')
    }
  }
}
